'use client';

import { useRouter } from 'next/navigation';

import { useDrawerStore } from '@/stores';
import { ROUTES } from '@/types/enums';

import { Button } from '../ui';

type PaymentDrawerProps = {
  onResetTimer?: () => void;
};

export const PaymentDrawer = ({ onResetTimer }: PaymentDrawerProps) => {
  const router = useRouter();
  const closeLastDrawer = useDrawerStore(
    (state) => state.forceCloseDrawerWithPreventClear,
  );
  const closeCurrentDrawer = useDrawerStore((state) => state.closeCurrentDrawer);

  const handleResetTimer = () => {
    onResetTimer?.();
    closeCurrentDrawer();
  };

  const handleClose = () => {
    closeLastDrawer();
    router.push(ROUTES.Enum['/']);
  };

  return (
    <div className="w-full flex flex-grow flex-col gap-3 px-4 pt-4">
      <p className="text-foreground text-center">
        Para gerar um novo QR Code e realizar o pagamento, clique no botão abaixo.
      </p>
      <Button
        variant="secondary"
        onClick={handleResetTimer}
        className="h-12 w-full p-4 text-base uppercase text-center"
      >
        Gerar QR Code novamente
      </Button>
      <Button size="large" variant="outlined" onClick={handleClose}>
        Sair
      </Button>
    </div>
  );
};
